import React from 'react';
import { Form, Field } from 'react-final-form';
import createDecorator from 'final-form-focus';
import { TextField } from 'final-form-material-ui';

import { validate } from 'utils/validate';
import { format } from 'utils/form';
import { schema } from './schema';

const focusOnErrors = createDecorator();

export default function ResultadosForm({ onSubmit, footer = () => {} }) {
  return (
    <Form
      onSubmit={onSubmit}
      decorators={[focusOnErrors]}
      validate={validate(schema)}
      render={props => (
        <form onSubmit={props.handleSubmit} noValidate>
          <Field
            name="associado_cpf"
            autoFocus
            type="text"
            component={TextField}
            {...format('XXX.XXX.XXX-XX')}
            label="CPF do associado"
            margin="normal"
            fullWidth
            variant="outlined"
          />
          {footer(props)}
        </form>
      )}
    />
  );
}
